import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import moment from "moment";
import { cleanValue } from "../../../utils/commonComponent/fetched";
import AptosNormal from "../../../utils/Customfonts/Aptos.ttf";
import AptosBold from "../../../utils/Customfonts/Aptos-Bold.ttf";
const HeaderImg = "/img/header.png";

let config = {
  margin: 20,
  borderMagin: 12,
  headerHeight: 80,
  footerHeight: 10,
  fontSize: 10,
  bordergap: 0,
  currentY: 0,
};

// draw border from all sides
const drawMarginRect = (doc) => {
  const totalWidth = doc.internal.pageSize.getWidth();
  const totalHeight = doc.internal.pageSize.getHeight();
  doc.setDrawColor(0);
  doc.setLineWidth(0.5);
  doc.rect(
    config?.borderMagin,
    config?.borderMagin + config?.headerHeight + config.bordergap,
    totalWidth - config?.borderMagin * 2,
    totalHeight -
      config?.borderMagin * 2 -
      (config?.headerHeight + config?.footerHeight) -
      config.bordergap
  );
};

// Helper function to draw the header and footer images
function addHeaderFooter(doc) {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let letterHead = HeaderImg;

  // Draw header image at the top (x:0, y:0)
  doc.addImage(letterHead, "PNG", 0, 0, pageWidth, config?.headerHeight);
  // doc.addImage(
  //   UnitechFooter,
  //   "PNG",
  //   0,
  //   pageHeight - config?.footerHeight,
  //   pageWidth,
  //   config?.footerHeight
  // );
}

function generateHeaderSection(doc, inputStates, selectedIndexes) {
  const invoiceTitle = "CUSTOMER FEEDBACK";
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(0, 0, 102);
  doc.text(
    invoiceTitle,
    doc.internal.pageSize.getWidth() / 2,
    config?.headerHeight + config?.margin + 5 + config.bordergap,
    {
      align: "center",
    }
  );
  const startYPos =
    config?.headerHeight + 12 + config.bordergap + config?.margin;

  // Calculate the total available width of the table
  const totalPageWidth = doc.internal.pageSize.getWidth() - config.margin * 2;
  const columnPercentages = [40, 12, 12, 12, 12, 12];
  const columnWidths = columnPercentages.map((percentage) => {
    return (totalPageWidth * percentage) / 100;
  });

  const bodyData = [
    [
      {
        content: "Name of the Organization - Customer",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.companyName),
        colSpan: 4,
        // inputStates?.inspectionDate
        //   ? moment(inputStates?.inspectionDate).format("DD/MM/YYYY")
        //   : "" + cleanValue(inputStates?.duration),
      },
    ],
    [
      {
        content: "Address - Location",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.address),
        colSpan: 4,
      },
    ],
    [
      {
        content: "Contact Person - Position / Designation",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content: cleanValue(inputStates?.contact),
        colSpan: 4,
      },
    ],
    [
      {
        content: "Phone - Mobile Number | E-mail ID",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 2,
      },
      {
        content:
          cleanValue(inputStates?.contactNumber) +
          " | " +
          cleanValue(inputStates?.emailId),
        colSpan: 4,
      },
    ],
    [
      {
        content:
          "DYC Global Inspections Private Limited is always looking for ways and means for improving our services. With this aim in mind, we have decided to collect your formal feedback every year to understand your expectations and plan actions to try and improve.\nYou are requested to kindly take few minutes and answer the following questions. Your comments and suggestions will be used to improve our system and ability to serve you better in future.",
        styles: {
          halign: "justify",
          cellPadding: { top: 5, left: 5, bottom: 5, right: 10 },
        },
        colSpan: 6,
      },
    ],
    [
      {
        content: "Parameter",
        styles: { fontStyle: "bold", halign: "left" },
      },
      {
        content: "Strongly Agree",
        styles: { fontStyle: "bold", halign: "center" },
      },
      {
        content: "Agree",
        styles: { fontStyle: "bold", halign: "center" },
      },
      {
        content: "Neutral",
        styles: { fontStyle: "bold", halign: "center" },
      },
      {
        content: "Disagree",
        styles: { fontStyle: "bold", halign: "center" },
      },
      {
        content: "Strongly Disagree",
        styles: { fontStyle: "bold", halign: "center" },
      },
    ],
  ];

  const checkboxSymbols = {
    checked: "☑", // or use "✔" if you prefer tick only
    unchecked: "☐",
  };

  const feedbackQuestions = [
    {
      key: "deliveryServices",
      label: "Our team delivered all contracted services.",
    },
    {
      key: "qualityWork",
      label: "The quality of the contracted work was satisfactory.",
    },
    {
      key: "contractTime",
      label: "The contracted work was performed in a timely manner.",
    },
    {
      key: "hired",
      label: "You would hire us again?",
    },
    {
      key: "serviceRecommendation",
      label:
        "Would you recommend our service to contacts within your industry?",
    },
  ];

  feedbackQuestions.forEach(({ key, label }) => {
    const checkedIndex = selectedIndexes?.[key]; // 1-5
    const row = [
      {
        content: label,
        styles: { fontStyle: "bold", halign: "left" },
      },
      ...[1, 2, 3, 4, 5].map((val) => ({
        content:
          checkedIndex === val
            ? checkboxSymbols.checked
            : checkboxSymbols.unchecked,
        styles: {
          halign: "center",
          fontStyle: "normal",
          fontSize: config.fontSize + 2,
        },
      })),
    ];
    bodyData.push(row);
  });

  bodyData.push(
    [
      {
        content: "Any Suggestions for our Organizational.",
        styles: { fontStyle: "bold", halign: "left" },
        colSpan: 6,
      },
    ],
    [
      {
        content: cleanValue(inputStates?.suggestion1),
        colSpan: 6,
      },
    ]
  );

  autoTable(doc, {
    startY: startYPos,
    body: bodyData,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      valign: "middle",
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
      font: "AptosNormal",
    },
    margin: {
      top: config?.borderMagin + config?.headerHeight + config.bordergap + 5,
      left: config.margin,
      right: config.margin,
      bottom: config.footerHeight + config.bordergap + 10,
    },
    headStyles: { fillColor: [217, 217, 217] },
    columnStyles: {
      0: { cellWidth: columnWidths[0] },
      1: { cellWidth: columnWidths[1] },
      2: { cellWidth: columnWidths[2] },
      3: { cellWidth: columnWidths[3] },
      4: { cellWidth: columnWidths[4] },
      5: { cellWidth: columnWidths[5] },
    },
  });

  // Get the Y position after the first table
  let firstTableEndY = doc.lastAutoTable.finalY;
  // Create separate signature table with same column structure
  const signatureTableData = [
    [
      {
        content: "",
        colSpan: 3, // First column will span 3
        styles: {
          minCellHeight: 50,
        },
      },
      {
        content: "", // Leave content empty for the second column
        colSpan: 3, // Second column will span 3
        styles: {
          minCellHeight: 50,
        },
      },
    ],
  ];
  // Estimate minimum height needed for the second table (signature)
  const estimatedSignatureTableHeight = 60;
  const pageHeight = doc.internal.pageSize.getHeight();
  const bottomMargin = config.footerHeight + config.bordergap + 10;
  const remainingHeight = pageHeight - firstTableEndY - bottomMargin;
  if (remainingHeight < estimatedSignatureTableHeight) {
    doc.addPage();
    firstTableEndY = config.headerHeight + config.margin;
  }
  // Second table for signatures only
  autoTable(doc, {
    startY: firstTableEndY + 5, // Small gap between tables
    body: signatureTableData,
    theme: "grid",
    styles: {
      fontSize: config.fontSize,
      textColor: 0,
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      valign: "middle",
      cellPadding: { top: 5, left: 5, bottom: 5, right: 5 },
      font: "AptosNormal",
    },
    margin: {
      top: config?.borderMagin + config?.headerHeight + config.bordergap + 5,
      left: config.margin,
      right: config.margin,
      bottom: config.footerHeight + config.bordergap + 10,
    },
    didDrawCell: (data) => {
      const { section } = data;
      if (section === "body") {
        const cell = data.cell;
        const rowIndex = data.row.index;
        const columnIndex = data.column.index;

        // Prepared By Signature (left side)
        if (rowIndex === 0 && columnIndex === 0) {
          if (inputStates.preparedBySign) {
            const imgWidth = 60;
            const imgHeight = cell.height - 20;
            const x = cell.x + 5;
            const y = cell.y + 17;
            // Draw label above image
            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text("Prepared By Signature:", x, cell.y + 12);
            // Draw image
            doc.addImage(
              inputStates.preparedBySign,
              "PNG",
              x,
              y,
              imgWidth,
              imgHeight
            );
          }
        }
        // Approved By Signature (right side)
        if (rowIndex === 0 && columnIndex === 3) {
          if (inputStates.approvedBySign) {
            const imgWidth = 60;
            const imgHeight = cell.height - 20;
            const x = cell.x + 5;
            const y = cell.y + 17;
            // Draw label above image
            doc.setFontSize(10);
            doc.setFont("helvetica", "bold");
            doc.text("Approved By Signature:", x, cell.y + 12);
            // Draw image
            doc.addImage(
              inputStates.approvedBySign,
              "PNG",
              x,
              y,
              imgWidth,
              imgHeight
            );
          }
        }
      }
    },
  });

  const newY = doc.lastAutoTable.finalY;
  config.currentY = newY;
}

const loadAndAddFont = async (
  pdfDoc,
  fontUrl,
  fontNameTTF,
  fontName,
  fontStyle
) => {
  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 8192; // Process in chunks for large buffers
    for (let i = 0; i < bytes.length; i += chunkSize) {
      binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
    }
    return btoa(binary);
  };

  const fontResponse = await fetch(fontUrl);
  const fontBuffer = await fontResponse.arrayBuffer();
  const fontBase64 = arrayBufferToBase64(fontBuffer);

  pdfDoc.addFileToVFS(`${fontNameTTF}.ttf`, fontBase64);
  pdfDoc.addFont(`${fontNameTTF}.ttf`, fontName, fontStyle);
};

export async function generatePDFCustomerFeedback(
  inputStates,
  selectedIndexes,
  letterHead
) {
  const doc = new jsPDF({
    orientation: "p",
    unit: "pt",
    format: "a4",
    compress: true,
  });
  await Promise.all([
    loadAndAddFont(doc, AptosNormal, "Aptos", "AptosNormal", "normal"),
    loadAndAddFont(doc, AptosBold, "Aptos-Bold", "AptosBold", "bold"),
  ]);

  // Set default font
  doc.setFont("AptosNormal");
  doc.setFont("AptosBold");

  generateHeaderSection(doc, inputStates, selectedIndexes);

  const pageCount = doc.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    if (letterHead) {
      addHeaderFooter(doc);
    }
    drawMarginRect(doc);
  }

  const totalPages = doc.getNumberOfPages();
  for (let page = 1; page <= totalPages; page++) {
    doc.setPage(page);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(config.fontSize - 1);
    doc.setTextColor(0);
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const bottomY = pageHeight - config.borderMagin;
    let leftText = `Page No : ${String(page).padStart(2, "0")} of ${String(
      totalPages
    ).padStart(2, "0")}`;
    let rightText = "Format No. BFI-FM-SALES-4, Rev.1, Rev. Date: 05/08/2023";
    doc.text(leftText, config.margin - 5, bottomY);
    doc.text(rightText, pageWidth - config.margin - 250, bottomY); 
  }

  doc.save(`service_request.pdf`);
}
